function getProperties() {
  console.log('script running...');
  
  var id = document.querySelector('.hulkapp_save.btn').getAttribute('data-variant_id');
  var itemKey = document.querySelector('.hulkapp_save.btn').getAttribute('data-key');
  var qty = document.querySelector('.hulkapp_save.btn').getAttribute('data-quantity');
  var properties = document.querySelector(".edit-option[data-variant_id='" + id + "']");
  document.querySelector('[name="id"]').value = id;

  $.ajax({
    url: '/cart.js',
    method: 'GET',
    dataType: 'json',
    success: function(data) {
      console.log('Cart data:', data);
      data.items.forEach((item) => {
        if (item.key == itemKey) {
          console.log('correct item found: ', item);
          for (var key in item.properties) {
            if (key == 'Upload your Existing Sticker or Artwork') {
              continue
            }
            var hiddenInput = document.createElement('input');
            hiddenInput.type = 'hidden';
            hiddenInput.name = 'properties[' + key + ']';
            hiddenInput.value = item.properties[key];
            document.querySelector('.hulkapps_options_container').appendChild(hiddenInput);
          }
        }
      })
    },
    error: function(xhr, status, error) {
      console.error('Error fetching cart data:', error);
    }
  });
}

function changeItem(event) {
  event.preventDefault();
  var id = document.querySelector('.hulkapp_save.btn').getAttribute('data-variant_id');
  var qty = document.querySelector('.hulkapp_save.btn').getAttribute('data-quantity');
  var key = document.querySelector('.hulkapp_save.btn').getAttribute('data-key');

  var formData = new FormData($('#edit_cart_popup')[0]);
  formData.append('quantity', qty);
  formData.append('line', id);
  
  $.ajax({
  type: 'POST',
  url: '/cart/change.js',
  data: {
    quantity: 0,
    id: key
  },
  dataType: 'json',
  success: function (cart) {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: formData,
        dataType: 'json',
        contentType: false,
        processData: false,
        success: function () {
          $(".hulkapp_close").click();
          location.reload();
        }
      })
    }
  })
}